import { Component, ViewChild } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { GridMenuItem } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid-menu/grid-menu-item';
import { GridComponent } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid.component';
import { CellValueType, IGridColumn } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-column';
import { ModalService } from '../../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { ApiClientAdminCompany } from '../../../../api/endpoints/ApiClientAdminCompany';
import { CompanyEditComponent } from './company-edit.component';
import { FilterType } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/filter-type';
import { HttpApiRequestOptions } from '../../../../api/endpoints/HttpApiRequestOptions';
import { CompanyCreateComponent } from './company-create.component';
import { Icons } from '../../../../../../../libs/utils/ng-shared-components/src/lib/icon/icons';
import { CompanyDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/dtos/CompanyDto';
import { PersonDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/dtos/PersonDto';
import { enumName_mi_shared } from '../../../../../../../libs/utils/ts-shared/src/lib/api/enums/_enumName.mi_shared';
import { moduleName } from '../../../../../../../libs/utils/ts-shared/src/lib/module-names';
import { PersonFiltersDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/persons/PersonFiltersDto';
import { CompanyFiltersDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/persons/CompanyFiltersDto';
import { PagedSearchDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto';
import { ActivatedRoute } from '@angular/router';
import { RelatedEntityIssuePopupService } from '../../issue/related-entity-issue-popup/related-entity-issue-popup.service';
import { NotificationService } from '../../../../../../../libs/utils/ng-shared-components/src';

@Component({
  standalone: false,
  selector: 'mf-company-grid',
  templateUrl: './company-grid.component.html',
  styleUrls: ['./company-grid.component.scss'],
})
export class CompanyGridComponent {
  constructor(
    public _apiClientAdminCompany: ApiClientAdminCompany,
    private _modalService: ModalService,
    private _activatedRoute: ActivatedRoute,
    private _relatedEntityIssuePopupService: RelatedEntityIssuePopupService,
    private _notificationService: NotificationService
  ) {
    this.initialFilters.id = this._activatedRoute.snapshot.queryParams.id;
  }

  @ViewChild('grid')
  grid: GridComponent;

  initialFilters = new CompanyFiltersDto();

  columns: IGridColumn<CompanyDto>[] = [
    {
      field: nameof<CompanyDto>((p) => p.fullName),
      header: 'Nombre',
      width: 20,
      filter: {
        propertyName: nameof<PersonFiltersDto>((p) => p.defaultTextSearch),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<CompanyDto>((p) => p.email),
      header: 'Email',
      width: 20,
      filter: {
        propertyName: nameof<PersonFiltersDto>((p) => p.email),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<CompanyDto>((p) => p.idDocument.type),
      header: 'Tipo de documento',
      width: 20,
      cellOptions: {
        type: CellValueType.Enum,
        enumName: enumName_mi_shared.IdDocumentType,
        enumNameModule: moduleName.shared,
      },
    },
    {
      field: nameof<PersonDto>((p) => p.idDocument.documentNumber),
      header: 'Documento',
      width: 20,
      filter: {
        propertyName: nameof<PersonFiltersDto>((p) => p.documentNumber),
        type: FilterType.Text,
      },
    },
  ];

  menuItems: GridMenuItem[] = [
    {
      label: 'Editar',
      icon: Icons.edit,
      onClick: (companyDto: CompanyDto) => {
        this._modalService.openRightModal(CompanyEditComponent, {
          openData: companyDto.id,
          onCloseSuccess: () => {
            this.grid.reloadPage();
            this._relatedEntityIssuePopupService.checkRelatedIssuesAndOpenPopup(companyDto.id);
          },
        });
      },
    },
    {
      label: 'Eliminar',
      icon: Icons.delete,
      onClick: (companyDto: CompanyDto) => {
        this._modalService.openYesOrNoModal({
          openData: {
            title: '¿Está seguro de que desea eliminar este registro?',
          },
          onCloseSuccess: async () => {
            await this._apiClientAdminCompany.delete(companyDto.id);
            this._notificationService.showSuccess('El registro se eliminó con éxito');
            this.grid.reloadPage();
          },
        });
      },
    },
  ];

  apiEndpoint = (search: PagedSearchDto<CompanyFiltersDto>, httpApiRequestOptions: HttpApiRequestOptions) =>
    this._apiClientAdminCompany.getPaged(search, httpApiRequestOptions);

  openNewCompanyPopup() {
    this._modalService.openRightModal(CompanyCreateComponent, {
      onCloseSuccess: () => {
        this.grid.reloadPage();
      },
    });
  }
}
